import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setConfigurator } from '../actions'
import Options from './Options'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configurator: state.configurator,
  campaign: state.configuration.campaign
})

const mapDispatchToProps = {
  setWizards,
  setConfigurator
}

export default connect(mapStateToProps, mapDispatchToProps)(Options)
